export default function() {

    $(document).ready(function() {
        $('.js-facebook-sharer').on('click', function(ev){
            ev.preventDefault();
            var $url = $(location).attr('href');
            window.open(
            'https://www.facebook.com/sharer/sharer.php?u='+$url, 
            'facebook-share-dialog', 
            'width=626,height=436'); 
        });

        $('.js-twitter-sharer').on('click', function(ev){
            ev.preventDefault();
            var $url = $(location).attr('href');
            window.open(
                'https://twitter.com/intent/tweet?url='+$url, 
                'twitter-share-dialog', 
                'width=626,height=436'); 
        });

        $('.js-copy-link').on('click', function(ev){
            ev.preventDefault();
            var feedbackMessage = $(this).attr('data-feedback');
            var $temp = $('<input>');
            var $url = $(location).attr('href');
            $('body').append($temp);
            $temp.val($url).select();
            document.execCommand('copy');
            $temp.remove();
            Snackbar.show({
                text: feedbackMessage,
                pos: 'top-center',
                actionText: '×',
                actionTextColor: '#ffffff',
                backgroundColor: '#0068B1',
                textColor: '#ffffff'
            });

        })

    });
}